module.exports = __webpack_public_path__ + "img/_dsc8167.55bac1e6.jpg";